
export default {
  routeExtras: {
    extras: 'Extras da rota',
    extraInfo: 'Informações extra',
    value: 'Valor',
    clickToHighlightOnMap: 'Clique para destacar no mapa',
    showAllOnMap: 'Mostrar tudo no mapa'
  }
}
